import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import {
  eventSelector,
  branchGatedChatLinkSelector
} from 'src/selectors'

import Button from 'components/common/Button'
import HobnobNavBar from 'components/common/HobnobNavBar'

import styles from './no-guest-chat-page.scss'

export class NoGuestChatPage extends React.Component {
  render () {
    const { event, downloadLink } = this.props

    return (
      <div>
        <HobnobNavBar title='Event Chat' subTitle={event.name} backPathName='details' />
        <div className={styles['container']}>
          <div className={styles['spacer']} />
          <div className={styles['content']}>
            <div className={styles['text']}>
              To chat about the event, get the Hobnob app!
            </div>
            <div className={styles['download-app-button-container']}>
              <Button wrapperElement={'a'} href={downloadLink} >
                Download App
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

NoGuestChatPage.propTypes = {
  event: PropTypes.object,
  downloadLink: PropTypes.string.isRequired
}

function mapStateToProps (state) {
  return {
    event: eventSelector(state),
    downloadLink: branchGatedChatLinkSelector(state)
  }
}

export default connect(mapStateToProps)(NoGuestChatPage)



// WEBPACK FOOTER //
// ./src/containers/NoGuestChatPage.jsx